// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React, { memo } from "react";

import { OptionalTitle, NoTitle } from "./styles";
import Icon from "src/components/Icon";
import * as colors from "src/styles/constants/colors";
import { iconSize } from "src/styles/constants/size";
import Privacy from "src/components/chatroom/Privacy";
import WorkflowName from "src/containers/workflow/Name";

import type { RoomId } from "src/types";

type Props = {
  type: string,
  title: string,
  templateId?: ?number,
  seqNo: number,
  roomId: RoomId,
};

const Title = ({ type, templateId = null, title, seqNo, roomId }: Props) => (
  <>
    <Icon icon={type} color={colors.secondary} size={iconSize.space_l} />
    <Privacy roomId={roomId} />
    <h4>
      {templateId && type === "workflow" ? (
        <>
          <WorkflowName id={templateId} /> {seqNo && `${i18n.t(k._7)}${seqNo}`}
          {i18n.t(k._)}
        </>
      ) : null}
      <OptionalTitle data-cy="current-chatroom-title" title={title}>
        {title}
        {type === "workflow" && (title || "").length === 0 ? (
          <NoTitle>{i18n.t(k.UNTITLED)}</NoTitle>
        ) : null}
      </OptionalTitle>
    </h4>
  </>
);

export default memo<Props>(Title);
